import React from 'react';
import PropTypes from 'prop-types';

import { ICONS } from 'constants/icons';
import InfoBanner, { BANNER_VARIANTS } from 'components/InfoBanner/InfoBanner';

import { messages } from './PricingActionRequiredBanner.messages';

const PricingActionRequiredBanner = ({ onDismiss }) => (
  <InfoBanner
    hideCTA
    icon={ICONS.warningYellow}
    onClose={onDismiss}
    showCloseButton
    subtitle={messages.subtitle}
    title={messages.title}
    variant={BANNER_VARIANTS.YELLOW}
  />
);

PricingActionRequiredBanner.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

export default PricingActionRequiredBanner;
